import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ResolvableServiceUsages_CustomizeAll_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ResolvableServiceUsages_CustomizeAll(
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      customizeMissionServiceUsages(
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useCustomizeAllMissionResolvableServiceUsagesMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ResolvableServiceUsages_CustomizeAll_Mutation,
  );
